import React, { FC } from 'react';
import { ScrollView, View } from 'react-native';
import { scale } from '@components/frame';
import { DETAILS_SCREENS_CONTAINER_STYLES_FOR_SCROLL_VIEW, SCREEN_PADDING_HORIZONTAL_FOR_ITEM, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import PartGeneralContent from './PartGeneralContent';
import ImagesContainer, { ImagesContainerMode } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { useManagePartListOrSingleItem } from '@v2/pages/machines/modules/now/components/Part/hooks/useManagePartListOrSingleItem';

export interface PartListOrSingleItemProps {
  partDataLoadingForList?: boolean;
  partId?: number | null;
  displaySinglePart?: boolean;
}

const PartListOrSingleItem: FC<PartListOrSingleItemProps> = (props) => {
  const { partDataLoadingForList, displaySinglePart, partId } = props;

  const {
    parts,
    onPartImagePress,
    maxWidth,
    maxDetailsWidth,
    bg,
    showImages,
    showSideImagesContainer,
  } = useManagePartListOrSingleItem(props);

  return (
    <View
      style={{
        flexDirection: 'row',
        maxWidth: scale(maxWidth),
        marginInline: 'auto',
        width: '100%',
        flex: 1,
      }}
    >
      <ScrollView contentContainerStyle={DETAILS_SCREENS_CONTAINER_STYLES_FOR_SCROLL_VIEW} showsVerticalScrollIndicator={false}>
        <PartGeneralContent
          displaySinglePart={displaySinglePart}
          loading={!parts.wasLoaded}
          partDetails={parts.data}
          maxDetailsWidth={maxDetailsWidth}
          noMachine
          withImages={showImages}
          currentPartId={partId}
          partDataLoadingForList={partDataLoadingForList}
          bg={bg}
        />
      </ScrollView>
      {showSideImagesContainer && (
        <View testID={TEST_IDS.partGeneralContent.sideImagesContainer} style={{ paddingTop: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}>
          <ImagesContainer
            panelViewMode
            mode={ImagesContainerMode.COLUMN}
            documentRetrieveId={parts?.data?.[0]?.partId}
            documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Part}
            onImagePress={onPartImagePress}
          />
        </View>
      )}
    </View>
  );
};

export { PartListOrSingleItem };
